import { Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import { AdminProvider, useAdmin } from "../context/AdminContext";

const AppRoutes = () => {
  const { admin, isLoading, authenticated } = useAdmin();
  
  if (isLoading && !authenticated) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {authenticated && (
          <Route path="/*" element={<PrivateRoute authenticated={authenticated} />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<LayoutRoutes role={admin?.role} />} />
          </Route>
        )}

        <Route
          path="/login"
          element={!authenticated ? <Signin /> : <Navigate to="/dashboard" replace />}
        />

        {authRoutes.map(({ path, Component }, i) => (
          <Route
            key={i}
            path={path}
            element={!authenticated ? Component : <Navigate to="/dashboard" replace />}
          />
        ))}

        <Route path="*" element={<Navigate to={authenticated ? "/dashboard" : "/login"} replace />} />
      </Routes>
    </Suspense>
  );
};

const Routers = () => {
  return (
    <BrowserRouter basename="/">
      <AdminProvider>
        <AppRoutes />
      </AdminProvider>
    </BrowserRouter>
  );
};

export default Routers;
